var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-view"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('info-page-not-found')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }